var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Multipanel__Icn/40px/Multipanel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,10 L22,29 L16,29 L16,27 L20,27 L20,12 L16,12 L16,10 L22,10 Z M34,19.5 L26,24.5 L26,14.5 L34,19.5 Z M31,19.5003519 L26,16.5 L26,22.5 L31,19.5003519 Z M14,10 L5,10 L5,29 L14,29 L14,10 Z M12,12 L12,27 L7,27 L7,12 L12,12 Z",
    id: ".._.._src_svg_Icn_40px_Multipanel__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipanel);
export default __webpack_public_path__ + "static/media/Multipanel.0013f84f873320d75acf99c7937148e8.svg";
export { ForwardRef as ReactComponent };